import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import React from 'react'

import { getLanguage } from 'data/locale'

const ProfileGiftAnalysisModal = ({ onClose, opened, name, content }) => {
  const { t } = getLanguage()

  return (
    <Dialog className="Profile-gift-analysis-dialog" open={opened} onClose={onClose}>
      <DialogTitle>Gift Detail</DialogTitle>
      <DialogContent>
        <span className="Profile-gift-analysis-dialog-modal-name">{name}</span>
        {content}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="text">
          {t.global.close}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ProfileGiftAnalysisModal
